import React from 'react';
import styled, { css } from 'styled-components/macro';

import { ColorVariants } from 'theme';
import Typography from 'components/Typography';
import media from 'helpers/media';

export const PlanRoot = styled.div<{ $height?: string }>`
    background: ${({ theme }) => theme.colors.white};
    border-radius: 8px;
    width: 100%;

    ${({ $height }) =>
        $height &&
        css`
            height: ${$height};
        `};
`;

export const PlanHeadline = styled.div<{
    $color: ColorVariants;
    $textColor?: ColorVariants;
}>`
    text-align: center;
    color: ${({ theme, $textColor }) =>
        $textColor ? theme.colors[$textColor] : theme.colors.white};
    background-color: ${({ theme, $color }) => theme.colors[$color]};
    padding: ${({ theme }) => `${theme.space.base} ${theme.space.sbase}`};
    border-radius: 8px 8px 0px 0px;
`;

export const PlanBody = styled.div`
    padding: ${({ theme }) => theme.space.medium};
`;

export const PlanFeatures = styled.div<{ $hideOnMobile?: boolean }>`
    color: ${({ theme }) => theme.colors.baseGray};
    padding-left: ${({ theme }) => theme.space.giant};
    padding-right: ${({ theme }) => theme.space.base};
    margin-top: ${({ theme }) => theme.space.medium};

    font-size: 0.875rem;
    line-height: 150%;

    .PItem_sc {
        position: relative;

        &:not(:first-child) {
            margin-top: ${({ theme }) => theme.space.sbase};
        }

        &.off {
            color: ${({ theme }) => theme.colors.inactive};
            text-decoration: line-through;
        }

        .ic_sc {
            position: absolute;
            top: 4px;
            left: -24px;
        }
    }

    ${({ $hideOnMobile }) => $hideOnMobile && media.mobile`display: none;`}
`;

export const PlanPrintsWrapper = styled.div`
    padding-left: ${({ theme }) => theme.space.giant};
    margin-top: ${({ theme }) => theme.space.sbase};

    ${media.mobile`display: none;`}
`;

export const PlanHeader = styled((props) => <Typography {...props} />)<{
    $color?: ColorVariants;
}>`
    ${({ theme, $color }) =>
        $color &&
        css`
            & > span {
                color: ${theme.colors[$color]};
            }
        `}
`;
